import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import RpTable from 'rp-react-table';
import columns from './columns';
import FigureRow from './FigureRow';
import mergeWithMR from './mergeWithMR';
import { figuresType, formType, raceRecordsType, myRatingsType } from '../dataPropTypes';

const RaceRecords = ({
    figures,
    data,
    onFilterClick,
    selectedFilter,
    params: { mr: { isShown: isMRShown } },
}) => (
    <section className="hp-raceRecords">
        <div className="hp-raceRecords__header">
            <h2 className="hp-raceRecords__title">Race Record</h2>
            <div>
                {Object.keys(figures).map(key =>
                    <FigureRow
                        figures={figures[key]}
                        type={key}
                        key={key}
                    />
            )}
            </div>
        </div>
        <RpTable
            data={isMRShown ? mergeWithMR(data) : data.raceRecords}
            className={classNames(
                'hp-raceRecords',
                isMRShown && 'hp-raceRecords__my-ratings',
            )}
            columns={columns(onFilterClick, selectedFilter)}
            uiType={2}
            initialSortIdx={10}
            noDataText="No race record for this horse"
        />
    </section>
    );

RaceRecords.propTypes = {
    figures: PropTypes.objectOf(figuresType),
    onFilterClick: PropTypes.func.isRequired,
    selectedFilter: PropTypes.string,
    params: PropTypes.shape({
        mr: PropTypes.shape({
            isShown: PropTypes.bool,
        }),
    }),
    data: PropTypes.shape({
        form: PropTypes.arrayOf(formType),
        raceRecords: PropTypes.arrayOf(raceRecordsType),
        myRatings: myRatingsType,
    }),
};

export default RaceRecords;



// WEBPACK FOOTER //
// ./src/js/horse/form/raceRecords/RaceRecords.jsx